<template>
  <div class="cs-select-color">
    <div
      v-for="(color, index) in colors"
      :key="color.name"
      class="cs-material-form-radio"
      :style="{ backgroundColor: color.value }"
    >
      <div class="mf-radio">
        <label
          :key="index"
          :for="`color${index}`"
        >
          <input
            :id="`color${index}`"
            :key="(index, color.name)"
            v-model="content"
            type="radio"
            name="radioColor"
            :data-ga-event-label="getGAEventLabel(color.name, index)"
            data-ga-event="radio-color-template-select"
            :value="color.value"
            @change="handleRadio"
          />
          <i class="mf-radio-button" />
        </label>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BaseSelectColor',
  props: {
    value: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      content: '',
      colors: [
        { value: '#1474f5', name: 'blue' },
        { value: '#15d3c9', name: 'cyan' },
        { value: '#05c412', name: 'green' },
        { value: '#fccf00', name: 'yellow' },
        { value: '#f77c04', name: 'orange' },
        { value: '#cf2e58', name: 'red' },
        { value: '#ff86d5', name: 'pink' },
        { value: '#8726d9', name: 'purple' },
        { value: '#577b8d', name: 'gray' },
      ],
    };
  },
  watch: {
    value() {
      this.content = this.value;
      this.handleRadio();
    },
  },
  methods: {
    handleRadio() {
      this.$emit('input', this.content);
    },
    getGAEventLabel(colorName, index) {
      return `color-${index}-${colorName}`;
    },
  },
};
</script>

<style lang="scss" module>
:global {
  .cs-select-color {
    display: flex;
    flex-flow: row wrap;

    > .cs-material-form-radio {
      width: 24px;
      height: 24px;
      margin-right: var(--space-small-xx);
      background: var(--color-brand-primary-400);
      border-radius: 50%;

      &:last-child {
        margin-right: 0;
      }

      > .mf-radio {
        margin-bottom: 0;

        .mf-radio-button {
          &,
          &:before,
          &:after {
            width: 24px;
            height: 24px;
            color: var(--color-neutral-0);
          }

          &:before {
            box-shadow: 0 0 0 3px var(--color-neutral-0);
          }

          &:after {
            background: transparent;
            border: var(--border-width-medium) solid var(--color-neutral-0);
            transform: none;
          }
        }

        label {
          width: 24px;
          height: 24px;
          margin-bottom: 0;
        }

        input {
          &:checked {
            ~ .mf-radio-button {
              &::after {
                transform: none;
              }

              &:before {
                box-shadow: 0 0 0 1px var(--color-neutral-900);
              }
            }
          }
        }
      }
    }
  }
}
</style>
